import { render, staticRenderFns } from "./routerContainer.vue?vue&type=template&id=42b732de&scoped=true&"
import script from "./routerContainer.vue?vue&type=script&lang=js&"
export * from "./routerContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b732de",
  null
  
)

export default component.exports